import type { RoleResponse } from "~types/role";
import type { Roster, RosterResources, RosterResponse } from "~types/roster";

export const transformRoster = (response: RosterResponse, rolesResponse?: RoleResponse) => {
  const resources: RosterResources | undefined = response?.includes?.resources;
  const captains = rolesResponse?.data.map((role) => ({
    entityId: role.entityId,
    seasonId: role.seasonId,
    role: role.role,
    roleId: role.roleId,
    personId: role.personId,
  }));
  return (
    response?.data?.map((item: Roster) => {
      const captain = captains?.find((captain) => captain.entityId === item.entityId && captain.personId === item.personId);
      return {
        ...item,
        entity: resources?.[item.entity?.resourceType ?? ""]?.[item.entity?.id ?? ""],
        person: resources?.[item.person?.resourceType ?? ""]?.[item.person?.id ?? ""],
        fixture: resources?.[item.fixture?.resourceType ?? ""]?.[item.fixture?.id ?? ""],
        isCaptain: !!captain,
        captainRoleId: captain?.roleId,
      };
    }) || []
  );
};
